import API from '../apiCreate'
import { getParams } from '../getParams'
import type {
	CrmCallAnalysisScenarioPayload,
	CrmCallAnalysisScenarioType,
	ResponseCrmCallAnalysisCriteria,
	ResponseCrmCallAnalysisRun,
	ResponseCrmCallAnalysisScenario,
	ResponseCrmCallAnalysisScenarios,
	ResponseCrmCallAnalysisReport,
} from './crm-call-analysis.types'

export const crmCallAnalysisApi = {
	getRuns: (params: { page?: number; per_page?: number; status?: string }) =>
		API.get<ResponseCrmCallAnalysisReport>(
			`crm-call-analysis/runs${getParams(params)}`,
			{ skipGlobalErrorAlert: true } as any
		),
	getRun: (id: number) =>
		API.get<ResponseCrmCallAnalysisRun>(
			`crm-call-analysis/run${getParams({ id })}`,
			{ skipGlobalErrorAlert: true } as any
		),
	getScenarios: () =>
		API.get<ResponseCrmCallAnalysisScenarios>('crm-call-analysis/scenarios'),
	createScenario: (data: CrmCallAnalysisScenarioPayload) =>
		API.post<ResponseCrmCallAnalysisScenario>(
			'crm-call-analysis/scenarios',
			data
		),
	updateScenario: (id: number, data: CrmCallAnalysisScenarioPayload) =>
		API.patch<ResponseCrmCallAnalysisScenario>(
			`crm-call-analysis/scenarios/${id}`,
			data
		),
	deleteScenario: (id: number) =>
		API.delete(`crm-call-analysis/scenarios/${id}`),
	suggestCriteria: (type: CrmCallAnalysisScenarioType) =>
		API.post<ResponseCrmCallAnalysisCriteria>(
			'crm-call-analysis/scenarios/suggest-criteria',
			{ type }
		),
	activateScenario: (id: number) =>
		API.post(`crm-call-analysis/activate-scenario${getParams({ id })}`),
	retry: (id: number, scenarioId?: number) =>
		API.post<ResponseCrmCallAnalysisRun>(
			`crm-call-analysis/retry${getParams({ id })}`,
			scenarioId === undefined ? {} : { scenario_id: scenarioId }
		),
}
